import { REPORTS as type } from '@/store/types';
import Reports from '@/services/Api/Awards/Reports';

const state = {
  data: [],
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
};

const actions = {
  fetchReports({ commit }, params) {
    commit(type.LOADING, true);
    Reports.all(params).then((response) => {
      const { status, data } = response.data;
      if (status === 200) {
        commit(type.SET, data);
      }
    })
      .finally(() => {
        commit(type.LOADING, false);
      });
  },
};

const getters = {
  hasReports(state) {
    const items = state.data;
    return items?.length > 0;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
